import { Icon } from 'office-ui-fabric-react';
import React from 'react';
import RbLabel from '../../bosch-react/components/label/RbLabel';


const NoRecordsFound: React.FC<any> = () => {

    return (
        <div style={{
            textAlign: 'center',
            padding: '40px 20px',
            color: '#666',
            fontSize: '14px'
        }}>
            <div style={{ marginBottom: '10px' }}>
                <Icon iconName="SearchIssue" style={{ fontSize: '24px', color: '#a19f9d' }} />
            </div>
            <RbLabel>No records found</RbLabel>
            <div style={{ fontSize: '12px', marginTop: '8px' }}>
                Please adjust your search criteria or try different filters.
            </div>
        </div>
    );
};

export default NoRecordsFound;